import { PageHeader } from '../ui/PageHeader';

/**
 * PRO-1440 / ADR-071 — in-shell landing when a baseline-admitted caller has no
 * operational role and neither People Assistant nor Policies is flagged on.
 * Class 2 Wide; existing shell chrome.
 */
export function WelcomeView() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-6">
      <PageHeader
        title="You are in"
        intro="You have workforce access to TAG Operations. Request an operational role if you need Communications, Complaints, or another module."
      />
    </div>
  );
}
